"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.errors.stepsLoadFailed': 'Error al cargar los pasos',
    'tutorial.errors.avatarsLoadFailed': 'Error al cargar los avatares',
    'tutorial.errors.companiesLoadFailed': 'Error al cargar las empresas',
    'tutorial.errors.loadFailed': 'Error al cargar el tutorial',
};
